import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import FootBallImg from "../../../../assets/customerAssets/football.png";
import { useNavigate } from "react-router-dom";

const getTime = (duration) => {
  let temp = duration;
  if (duration > 60) {
    let min = 0;
    let sec = 0;
    min = Math.floor(temp / 60);
    sec = temp % 60;
    return `${min}:${sec}`;
  } else if (temp == 60) {
    return `1:00`;
  } else {
    return `0:${temp}`;
  }
};

const VideoComoponent = ({ img, duration, data }) => {
  const [viewGoal, setViewGoal] = useState(false);
  const navigate = useNavigate();


  //   "";
  return (
    <>
      <Box
        className="img_div"
        sx={img ? {} : { backgroundColor: "white", opacity: 0.6 }}
        onClick={() => navigate(`/viewClub/${data?.id}`)}
      >
        <img
          src={img ? img : FootBallImg}
          alt="video"
          className="img_fluid"
          style={img ? { objectFit: "cover" } : { objectFit: "contain" }}
        />
        {duration && <Box className="duration">{getTime(duration)}</Box>}
      </Box>
    </>
  );
};

export default VideoComoponent;
